const initialState = {
  subLocalities: null,
  subLocalitiesByLocation: null,
};

const subLocalityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_SUB_LOCALITIES":
      return {
        ...state,
        subLocalities: action.data,
      };
    case "GET_SUB_LOCALITIES_BY_LOCATION_ID":
      return {
        ...state,
        subLocalitiesByLocation: action.data,
      };
    case "ADD_SUB_LOCALITY":
    case "UPDATE_SUB_LOCALITY_BY_ID":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default subLocalityReducer;
